import { render, staticRenderFns } from "./achievement-item.vue?vue&type=template&id=9ca65318&scoped=true"
import script from "./achievement-item.vue?vue&type=script&lang=js"
export * from "./achievement-item.vue?vue&type=script&lang=js"
import style0 from "./achievement-item.vue?vue&type=style&index=0&id=9ca65318&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca65318",
  null
  
)

export default component.exports